import flatpickr from "flatpickr";
// import "flatpickr/dist/flatpickr.min.css";

import JustValidate from 'just-validate';
import SlimSelect from 'slim-select'
import intlTelInput from 'intl-tel-input';

import { startTimer, startTimerFromEndDate } from './timer.js';

import VilniusUniversitiesAndFaculties from './../../../public/vilnius_universities.json';
import RigaUniversitiesAndFaculties from './../../../public/riga_universities.json';
import KrakowUniversitiesAndFaculties from './../../../public/krakow_universities.json';

const checkoutForm = document.getElementById('checkoutForm');
let validator;

let personCapacity = 1;

document.addEventListener('DOMContentLoaded', ()=>{
    const checkoutPage = document.querySelector('body.page-template-page-checkout');

    if (!checkoutPage)
        return;


    //GENERAL:
    const bookingId = document.querySelector('main#main').dataset.bookingId;

    const html = document.documentElement;
    const currentCity = generalObject.currentCity;


    //SET UNIVERSITIES AND FACULTIES
    const allFaculties = [];
    let universities = [];

    if (currentCity.toLowerCase() === 'vilnius'){
        universities = VilniusUniversitiesAndFaculties;
    }else if (removeAccents(currentCity)  === 'riga'){
        universities = RigaUniversitiesAndFaculties;
    }else if (removeAccents(currentCity) === 'krakow'){
        universities = KrakowUniversitiesAndFaculties;
    }

    function removeAccents(str) {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    }


    Object.values(universities).forEach(faculties => {
        allFaculties.push(...faculties);
    });





    if (checkoutForm)
        validator = new JustValidate('#checkoutForm');


    let booking; // ??


    fetchBooking();



    const createPersonModule = (personId, dependencies) => {
        const { validator, universities, countries, dateRange } = dependencies;

        // Private state - only this module can access
        let facultySlimSelect = null;
        let universitySlimSelect = null;
        let nationalitySlimSelect = null;
        let birthdayCalendar = null;

        // Cache DOM elements with person-specific selectors
        const elements = {
            universitySelect: () => document.querySelector(`#${personId}-university`),
            facultySelect: () => document.querySelector(`#${personId}-faculty`),
            nationalitySelect: () => document.querySelector(`#${personId}-nationality`),
            stayPurposeSelect: () => document.querySelector(`#${personId}-stay-purpose`),
            inputUniversity: () => document.querySelector(`.${personId}-input-university`),
            inputFaculty: () => document.querySelector(`.${personId}-input-faculty`),
            universityTextInput: () => document.querySelector(`.${personId}-university-text-input`),
            facultyTextInput: () => document.querySelector(`.${personId}-faculty-text-input`),

            studyYearSelect: () => document.querySelector(`#${personId}-study-year`),
            studyYearInput: () => document.querySelector(`.${personId}-input-study-year`),

            studyTypeSelect: () => document.querySelector(`#${personId}-study-type`),
            studyTypeInput: () => document.querySelector(`.${personId}-input-study-type`),


            genderSelect: () => document.querySelector(`#${personId}-gender`),

            whereDidYouHearAboutUsSelect: () => document.querySelector(`#${personId}-whereDidYouHearAboutUs`),

            phoneInput: () => document.querySelector(`#${personId}-phone`),

            birthdayInput: () => document.querySelector(`#${personId}-birthday`),
            ageModal: () => document.querySelector(`#${personId}-age-modal`),
        };

        const initValidation = () => {
            const validationRules = [
                { field: 'name', rules: [{ rule: 'required', errorMessage: 'Name is required' }] },
                { field: 'last-name', rules: [{ rule: 'required', errorMessage: 'Surname is required' }] },
                { field: 'email', rules: [{ rule: 'required' }, { rule: 'email' }] },
                { field: 'phone', rules: [{ rule: 'required', errorMessage: 'Phone is required' }] },
                { field: 'address', rules: [{ rule: 'required', errorMessage: 'Address is required' }] },
                { field: 'nationality', rules: [{ rule: 'required', errorMessage: 'Nationality is required' }] },
                { field: 'birthday', rules: [{ rule: 'required', errorMessage: 'Birthday is required' }] },
                { field: 'gender', rules: [{ rule: 'required', errorMessage: 'Gender is required' }] },
                { field: 'stay-purpose', rules: [{ rule: 'required', errorMessage: 'Stay purpose is required' }] },
                // { field: 'arrival-date', rules: [{ rule: 'required', errorMessage: 'Arrival date is required' }] }
            ];

            validationRules.forEach(({ field, rules }) => {
                validator.addField(`#${personId}-${field}`, rules);

                console.log(`#${personId}-${field}`)
            });
        };


        //SETUP CALENDARS:
        // const initCalendars = () => {
        //     if (elements.birthdayInput()) {
        //         const birthdayCalendar = flatpickr(`#${personId}-birthday`, {
        //             allowInput: true,
        //             // mode: "range",
        //             monthSelectorType: "dropdown",
        //             maxDate: 'today',
        //             // showMonths: 2,
        //             onReady: function(_, __, fp) {
        //             },
        //             onChange: function(selectedDates, dateStr, instance) {
        //                 // validateAge(selectedDates[0]);
        //             },
        //             onClose: function(selectedDates, dateStr, instance) {
        //                 // validateAge(selectedDates[0]);
        //             }
        //         });
        //     }
        //
        // }


        const initAgeValidation = () => {

            const ageModal = elements.ageModal();

            console.log('ageModal', elements.ageModal())

            if (!ageModal) return;

            const cancelAgeModalButton = ageModal.querySelector('.cancel-age-modal');
            const acceptAgeModalButton = ageModal.querySelector('.accept-age-modal');
            const acceptAgeCheckbox = ageModal.querySelector(`#${personId}-accept-age`);


            if (!acceptAgeCheckbox) return;

            const validateAge = (birthDate) => {
                if (!birthDate) return;

                const currentDate = new Date();
                let age = currentDate.getFullYear() - birthDate.getFullYear();

                const monthDiff = currentDate.getMonth() - birthDate.getMonth();
                if (monthDiff < 0 || (monthDiff === 0 && currentDate.getDate() < birthDate.getDate())) {
                    age--;
                }

                if (age < 18) {
                    toggleAgeModal();
                }
            };

            const toggleAgeModal = () => {
                if (ageModal.classList.contains('hidden')) {
                    ageModal.classList.remove('hidden');
                    acceptAgeCheckbox.checked = false;
                    acceptAgeModalButton.classList.add('is-disabled');
                } else {
                    ageModal.classList.add('hidden');
                }
            };

            // Event listeners
            acceptAgeCheckbox.addEventListener('change', () => {
                const wrapper = acceptAgeCheckbox.closest('.age-checkbox-wrapper');
                if (acceptAgeCheckbox.checked) {
                    wrapper.classList.remove('has-error');
                    acceptAgeModalButton.classList.remove('is-disabled');
                } else {
                    wrapper.classList.add('has-error');
                    acceptAgeModalButton.classList.add('is-disabled');
                }
            });

            acceptAgeModalButton.addEventListener('click', () => {
                const wrapper = acceptAgeCheckbox.closest('.age-checkbox-wrapper');

                if (acceptAgeCheckbox.checked) {
                    wrapper.classList.remove('has-error');
                    toggleAgeModal();
                } else {
                    wrapper.classList.add('has-error');
                }
            });

            cancelAgeModalButton.addEventListener('click', () => {
                if (birthdayCalendar) {
                    birthdayCalendar.clear();
                }
                toggleAgeModal();
            });

            // Initialize birthday calendar with age validation
            if (elements.birthdayInput()) {
                console.log('hrere')
                birthdayCalendar = flatpickr(`#${personId}-birthday`, {
                    allowInput: true,
                    monthSelectorType: "dropdown",
                    maxDate: 'today',
                    onReady: function(_, __, fp) {},
                    onChange: function(selectedDates, dateStr, instance) {},
                    onClose: function(selectedDates, dateStr, instance) {
                        validateAge(selectedDates[0]);
                    }
                });
            }
        };

        //INIT PHONE INPUT
        const initPhoneInput = () => {
            const phoneInput = elements.phoneInput();
            if (phoneInput){
                console.log('??')

                intlTelInput(phoneInput, {
                    hiddenInput: (telInputName) => ({
                        phone: `${personId}-phone-number`,
                    }),
                    separateDialCode: true,
                    initialCountry: 'auto',
                    geoIpLookup: callback => {
                        fetch("https://ipapi.co/json")
                            .then(res => res.json())
                            .then(data => callback(data.country_code))
                            .catch(() => callback("lt"));
                    },
                    autoPlaceholder: 'aggressive',
                    loadUtils: () => import("intl-tel-input/utils"),
                });
            }
        }


        const initSelects = () => {

            if (elements.nationalitySelect()) {
                nationalitySlimSelect = new SlimSelect({
                    select: `#${personId}-nationality`,
                    settings: { showSearch: true }
                });
            }


            // Stay purpose select
            if (elements.stayPurposeSelect()) {
                new SlimSelect({
                    select: `#${personId}-stay-purpose`,
                    settings: { showSearch: false }
                });
            }


            // Gender select
            if (elements.genderSelect()) {
                new SlimSelect({
                    select: `#${personId}-gender`,
                    settings: { showSearch: false }
                });
            }

            // Study Year select
            if (elements.studyYearSelect()) {
                new SlimSelect({
                    select: `#${personId}-study-year`,
                    settings: { showSearch: false }
                });
            }


            // University select
            if (elements.universitySelect()) {
                universitySlimSelect = new SlimSelect({
                    select: `#${personId}-university`,
                    settings: { showSearch: false }
                });
            }


            // Faculty select (initially)
            if (elements.facultySelect()) {
                facultySlimSelect = new SlimSelect({
                    select: `#${personId}-faculty`,
                    settings: { showSearch: false }
                });
            }

            //STUDY TYPE SELECT
            if (elements.studyTypeSelect()) {
                new SlimSelect({
                    select: `#${personId}-study-type`,
                    settings: {
                        showSearch: false,
                    }
                })
            }


            //where Did You Hear About Us select
            if (elements.whereDidYouHearAboutUsSelect()) {
                new SlimSelect({
                    select: `#${personId}-whereDidYouHearAboutUs`,
                    settings: { showSearch: false }
                });
            }
        };

        const generateFaculties = (faculties) => {
            const facultySelect = elements.facultySelect();
            const inputFaculty = elements.inputFaculty();
            const facultyTextInput = elements.facultyTextInput();
            const universityTextInput = elements.universityTextInput();

            if (!facultySelect) return;

            // Destroy existing SlimSelect
            if (facultySlimSelect) {
                facultySlimSelect.destroy();
                facultySlimSelect = null;
            }

            // Clear and rebuild options
            facultySelect.innerHTML = '';
            universityTextInput?.classList.add('hidden');

            if (faculties.length === 0) {
                inputFaculty?.classList.add('hidden');
                validator.removeField(`#${personId}-faculty`);
                validator.addField(`#${personId}-faculty-text`, [
                    { rule: 'required', errorMessage: 'Faculty is required' }
                ]);
                facultyTextInput?.classList.remove('hidden');
                return;
            } else {
                inputFaculty?.classList.remove('hidden');
                validator.addField(`#${personId}-faculty`, [
                    { rule: 'required', errorMessage: 'Faculty is required when purpose is Study' }
                ]);
            }

            // Add placeholder
            const placeholder = document.createElement('option');
            placeholder.value = '';
            placeholder.textContent = 'Select from the list';
            placeholder.disabled = true;
            placeholder.selected = true;
            facultySelect.appendChild(placeholder);

            if (faculties === allFaculties) {
                inputFaculty?.classList.add('hidden');
                validator.removeField(`#${personId}-faculty`);

                allFaculties.forEach(faculty => {
                    const option = document.createElement('option');
                    option.value = faculty;
                    option.textContent = faculty;
                    facultySelect.appendChild(option);
                });
            } else {
                // Loop through faculties and add options
                faculties.forEach(faculty => {
                    const option = document.createElement('option');
                    option.value = faculty;
                    option.textContent = faculty;
                    facultySelect.appendChild(option);
                });
            }


            //Note: IDK AR REIKIA
            // Add "Other" option
            // const otherOption = document.createElement('option');
            // otherOption.value = 'other';
            // otherOption.textContent = 'Other2';
            // facultySelect.appendChild(otherOption);

            // Re-init Faculty SlimSelect
            facultySlimSelect = new SlimSelect({
                select: `#${personId}-faculty`,
                settings: { showSearch: false }
            });
        };

        const handleUniversityChange = () => {
            console.log('i am here handleUniversityChange')

            const universitySelect = elements.universitySelect();
            const university = universitySelect?.value;

            if (!university) {
                // generateFaculties([]);
                generateFaculties(allFaculties);
                return;
            }



            if (university.toLowerCase() === 'other') {
                validator.removeField(`#${personId}-faculty`);
                validator.addField(`#${personId}-university-text`, [
                    { rule: 'required', errorMessage: 'University name is required' }
                ]);
                validator.addField(`#${personId}-faculty-text`, [
                    { rule: 'required', errorMessage: 'Faculty is required' }
                ]);

                elements.inputFaculty()?.classList.add('hidden');
                elements.universityTextInput()?.classList.remove('hidden');
                elements.facultyTextInput()?.classList.remove('hidden');
            } else {
                validator.removeField(`#${personId}-university-text`);
                validator.removeField(`#${personId}-faculty-text`);

                elements.universityTextInput()?.classList.add('hidden');
                elements.facultyTextInput()?.classList.add('hidden');

                generateFaculties(universities[university] || []);
            }
        };


        const handleFacultyChange = () => {
            const facultySelect = elements.facultySelect();
            const facultyTextInput = elements.facultyTextInput();

            if (facultySelect?.value?.toLowerCase() === 'other') {
                validator.addField(`#${personId}-faculty-text`, [
                    {
                        rule: 'required',
                        errorMessage: 'Faculty is required',
                    }
                ]);
                facultyTextInput?.classList.remove('hidden');
            } else {
                facultyTextInput?.classList.add('hidden');
                validator.removeField(`#${personId}-faculty-text`);
            }
        };

        const handleStayPurposeChange = () => {

            console.log('i am here handleStayPurposeChange')

            const stayPurposeSelect = elements.stayPurposeSelect();
            const purpose = stayPurposeSelect?.value;


            console.log(purpose)
            if (purpose === 'Study') {

                elements.inputUniversity()?.classList.remove('hidden');
                elements.inputFaculty()?.classList.remove('hidden');

                elements.studyYearInput()?.classList.remove('hidden');
                elements.studyTypeInput()?.classList.remove('hidden');

                validator.addField(`#${personId}-university`, [
                    { rule: 'required', errorMessage: 'University is required when purpose is Study' }
                ]);

                validator.addField(`#${personId}-faculty`, [
                    { rule: 'required', errorMessage: 'Faculty is required when purpose is Study' }
                ]);


                validator.addField(`#${personId}-study-year`, [
                    {
                        rule: 'required', errorMessage: 'Study year is required when purpose is Study'
                    },
                ]);

                validator.addField(`#${personId}-study-type`, [
                    {
                        rule: 'required',
                        errorMessage: 'Study type is required when purpose is Study'
                    },
                ]);

            } else {
                validator.removeField(`#${personId}-university`);
                validator.removeField(`#${personId}-faculty`);
                validator.removeField(`#${personId}-university-text`);
                validator.removeField(`#${personId}-faculty-text`);

                validator.removeField(`#${personId}-study-type`);
                validator.removeField(`#${personId}-study-year`);

                elements.inputUniversity()?.classList.add('hidden');
                elements.inputFaculty()?.classList.add('hidden');

                elements.universityTextInput()?.classList.add('hidden');
                elements.facultyTextInput()?.classList.add('hidden');

                elements.studyYearInput()?.classList.add('hidden');
                elements.studyTypeInput()?.classList.add('hidden');

                universitySlimSelect?.setSelected('');
                facultySlimSelect?.setSelected('');
            }
        };



        const bindEvents = () => {
            elements.universitySelect()?.addEventListener('change', handleUniversityChange);
            elements.stayPurposeSelect()?.addEventListener('change', handleStayPurposeChange);
            elements.facultySelect()?.addEventListener('change', handleFacultyChange);
        };

        const init = () => {
            initValidation();
            initSelects();
            bindEvents();
            // initCalendars();
            initPhoneInput();
            initAgeValidation();
            // Run initial state
            // handleStayPurposeChange();
        };

        const destroy = () => {
            // Clean up all SlimSelect instances
            facultySlimSelect?.destroy();
            universitySlimSelect?.destroy();
        };

        // Public API
        return {
            init,
            destroy,
            generateFaculties,
            handleUniversityChange,
            handleStayPurposeChange
        };
    };


    validator
        .addField('#guest-stay-purpose', [
            {
                rule: 'required',
                errorMessage: 'Stay purpose is required',
            },
        ])
        .addField('#guest-company-name', [
            {
                rule: 'required',
                errorMessage: 'Company name is required'
            },
        ])
        .addField('#guest-company-code', [
            {
                rule: 'required',
                errorMessage: 'Company code is required'
            },
        ])
        .addField('#guest-company-address', [
            {
                rule: 'required',
                errorMessage: 'Company address is required'
            },
        ])
        .addField('#privacy-policy', [
            {
                rule: 'required',
                errorMessage: ' '
            }
        ])
        .addField('#marketing', [
            {
                rule: 'required',
                errorMessage: ' '
            }
        ])


    // Create modules when needed
    const guestModule = createPersonModule('guest', {
        validator,
        universities,
        // countries
    });

    guestModule.init();



    //Company FIELDS
    const companyCheckbox = document.querySelector('#is-guest-company');
    const companyFieldsWrapper = document.querySelector('#companyFieldsWrapper');

    function updateCompanyValidation(){
        if (companyCheckbox.checked){

            companyFieldsWrapper.classList.remove('hidden')

            validator.addField('#guest-company-name', [
                {
                    rule: 'required',
                    errorMessage: 'Company name is required'
                },
            ]);
            validator.addField('#guest-company-code', [
                {
                    rule: 'required',
                    errorMessage: 'Company code is required'
                },
            ]);
            validator.addField('#guest-company-address', [
                {
                    rule: 'required',
                    errorMessage: 'Company address is required'
                },
            ]);
        }else{
            validator.removeField('#guest-company-name')
            validator.removeField('#guest-company-code')
            validator.removeField('#guest-company-address')

            companyFieldsWrapper.classList.add('hidden');
        }

    }

    companyCheckbox.addEventListener('change', updateCompanyValidation)
    updateCompanyValidation()
    //Company FIELDS END


    //REMOVE BOOKING
    const removeBookingButton = document.getElementById('removeBookingButton');

    if (removeBookingButton){
        removeBookingButton.addEventListener('click', ()=>{
            const data = new FormData();

            data.append('action', 'removeBooking');
            data.append('booking_id', bookingId);
            data.append('nonce', ajaxObject.nonce);

            fetch(ajaxObject.ajax_url, {
                method: 'POST',
                body: data,
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    // console.log('Success:', data);
                    window.location.href = ajaxObject.rooms_url;

                })
                .catch(error => {
                    console.error('Error:', error);
                });
        });
    }
    //REMOVE BOOKING END



    validator.onSuccess((event) => {

        event.preventDefault();
        setTimeout(() => {
            // Get all form data
            const data = new FormData(document.getElementById('checkoutForm'));
            data.append('action', 'create_checkout');
            data.append('booking_id', bookingId);
            data.append('nonce', ajaxObject.nonce);

            data.append('personCapacity', personCapacity)

            const formObject = {};
            for (let [key, value] of data) {
                formObject[key] = value;
            }
            // console.log(formObject);
            // return;


            fetch(ajaxObject.ajax_url, {
                method: 'POST',
                body: data,
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    console.log('Success:', data);

                    if (data.payseraRequest){
                        const paymentURL = `${data.payseraRequest.url}?data=${data.payseraRequest.data}&sign=${data.payseraRequest.sign}`;
                        // console.log(paymentURL)

                        window.location.href = paymentURL;
                    }

                })
                .catch(error => {
                    console.error('Error:', error);
                });
        }, 10);
    });

    validator.onFail((event) =>{
        console.log('Error')

        const checkboxWrapperBookings = document.querySelectorAll('.checkbox-wrapper-booking');

        checkboxWrapperBookings.forEach(checkboxWrapper=>{
            const input = checkboxWrapper.querySelector('input')

            if (!input){
                return
            }

            if (input.checked){
                checkboxWrapper.classList.remove('has-error');
            }else{
                checkboxWrapper.classList.add('has-error');
            }
        })
    });



    //CHECKBOXES errors
    document.querySelectorAll('.checkbox-wrapper-booking input').forEach(checkbox => {
        checkbox.addEventListener('change', () => {
            const wrapper = checkbox.closest('.checkbox-wrapper-booking');
            if (checkbox.checked) {
                wrapper.classList.remove('has-error');
            } else {
                wrapper.classList.add('has-error');
            }
        });
    });




    function fetchBooking(){
        const data = new FormData();

        data.append('action', 'get_booking');
        data.append('booking_id', bookingId);
        data.append('nonce', ajaxObject.nonce);

        fetch(ajaxObject.ajax_url, {
            method: 'POST',
            body: data
        })
            .then(response=>{
                if (!response.ok) {
                    throw new Error(`[${response.status}] ${response.statusText}`);
                }
                return response.json();
            })
            .then(response => {
                console.log(response);


                if (response?.expired) {
                    const submitBookingForm = document.getElementById('submit-booking-form');
                    submitBookingForm.disabled = true;
                    submitBookingForm.classList.add('button-disabled')
                }

                response.products.forEach(product=>{
                    if (product.productAssetType == 'room'){
                        personCapacity = product?.productPersonCapacity;

                        // Create modules when needed
                        if (personCapacity > 1) {
                            const additionalPerson1 = createPersonModule('additional_person_1', {
                                validator,
                                universities,
                                // countries
                            });

                            additionalPerson1.init();
                        }

                    }
                })

                const groupedProducts = response?.productsGrouped;

                if (response?.expiresAt) {
                    const expirationDate = new Date(response?.expiresAt);

                    if (document.querySelector('#time')) {
                        // console.log(expirationDate)

                        // Use the timer functions from timer-utils.js
                        var display = document.querySelector('#time');

                        startTimerFromEndDate(expirationDate, display, function () {
                            timeExpired()
                        });
                    }
                }


                if (groupedProducts && groupedProducts.length > 0){
                    groupedProducts.forEach(product=>{
                        if (product.productAssetType == 'room'){


                            const dateRawFrom = product?.from;
                            const dateRawTo = product?.to;

                            const fromDate = new Date(dateRawFrom);
                            const toDate = new Date(dateRawTo);

                            //SPLIT T TIME BECAUSE FLATPICKR doesnt care that much about time and we dont need time here too.
                            const dateFrom = fromDate.toISOString().split('T')[0];
                            const dateTo = toDate.toISOString().split('T')[0];


                            //SET ARRIVAL DATE
                            const arrivalDate = flatpickr('#guest-arrival-date',{
                                enable: [
                                    {
                                        from: dateFrom,
                                        to: dateTo
                                    },
                                ]
                            })

                            arrivalDate.jumpToDate(new Date(dateFrom))

                        }
                    })
                }


            })
            .catch(error => {
                console.error(error)
            })
    }



    function timeExpired(){
        const timerExpiredModal = document.getElementById('timerExpiredModal');
        const submitBookingForm = document.getElementById('submit-booking-form');
        timerExpiredModal.classList.remove('hidden');
        timerExpiredModal.classList.add('flex');

        submitBookingForm.disabled = true;
        submitBookingForm.classList.add('button-disabled');


        let count = 9;
        const display = document.getElementById('backToMainPageTime');
        const timer = setInterval(() => {
            display.textContent = count;
            if (count === 0) {
                clearInterval(timer);
                window.location.href = ajaxObject.rooms_url;
            }
            count--;
        }, 1000);

    }




    //PRIVACY POLICY MODAL
// Modal elements
    const modal = document.getElementById('privacy-policy-modal');
    const privacyPolicyCheckbox = document.getElementById('privacy-policy');
    const closeButton = document.querySelector('.close-button');
    const agreeButton = document.getElementById('agree-button');
    const cancelButton = document.getElementById('cancel-button');
    const policyContainer = document.getElementById('policy-container');
    // const scrollNotice = document.getElementById('scroll-notice');

// Form elements
    const privacyCheckbox = document.getElementById('privacy-checkbox');

// Track if user has scrolled to the bottom
    let hasScrolledToBottom = false;

// Function to show the modal
    function showPrivacyPolicy(event) {
        if (event) event.preventDefault();
        modal.style.display = 'flex';
        policyContainer.scrollTop = 0;
        agreeButton.disabled = true;
        // scrollNotice.style.display = 'block';
        hasScrolledToBottom = false; // Reset scroll state when modal opens

        html.classList.add('no-scroll')
    }

// Check if user has scrolled to the bottom
    function checkScrollPosition() {
        const scrollPosition = policyContainer.scrollTop;
        const scrollHeight = policyContainer.scrollHeight;
        const containerHeight = policyContainer.clientHeight;

        if (scrollPosition + containerHeight >= scrollHeight - 20) {
            agreeButton.disabled = false;
            // scrollNotice.style.display = 'none';
            agreeButton.classList.add('enabled');
            hasScrolledToBottom = true; // Set flag when user has scrolled to bottom
        }
    }

// Close the modal
    function closeModal() {
        modal.style.display = 'none';
        html.classList.remove('no-scroll')
    }

// Event listeners for modal
    policyContainer.addEventListener('scroll', checkScrollPosition);

    privacyPolicyCheckbox.addEventListener('click', (e)=>{
        e.preventDefault();
        showPrivacyPolicy();
    });

    // closeButton.addEventListener('click', closeModal);

    agreeButton.addEventListener('click', function() {
        // Check if user has actually scrolled to the bottom
        if (!hasScrolledToBottom) {
            // If they haven't scrolled, keep the button disabled and show a message
            agreeButton.disabled = true;

            policyContainer.scrollTop = 0;
            return;
        }

        // When user has legitimately scrolled and agrees, check the checkbox
        privacyPolicyCheckbox.checked = true;

        // Trigger change event for JustValidate to recognize
        const changeEvent = new Event('change', { bubbles: true });
        privacyPolicyCheckbox.dispatchEvent(changeEvent);

        // Store acceptance
        localStorage.setItem('privacyPolicyRead', 'true');
        closeModal();
    });

    cancelButton.addEventListener('click', function() {
        closeModal();
        // Uncheck the checkbox if they cancel
        privacyPolicyCheckbox.checked = false;

        // Trigger change event
        const changeEvent = new Event('change', { bubbles: true });
        privacyPolicyCheckbox.dispatchEvent(changeEvent);
    });
    //PRIVACY POLICY MODAL END
})